import { render, staticRenderFns } from "./QuoteFormCarrierProduct.vue?vue&type=template&id=0ca6aa72&scoped=true&"
import script from "./QuoteFormCarrierProduct.vue?vue&type=script&lang=ts&"
export * from "./QuoteFormCarrierProduct.vue?vue&type=script&lang=ts&"
import style0 from "./QuoteFormCarrierProduct.vue?vue&type=style&index=0&id=0ca6aa72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca6aa72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
